import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VSelect,{attrs:{"value":_vm.site,"items":_vm.items,"item-text":"url","item-value":"_id","dense":"","hide-details":"","outlined":""},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }